import React from "react";
import { AlertNotification, PatientSettings } from "@shared/models";
import { TableProperty } from "@shared/components/Table/interfaces";
import { AlertNotificationRowComponent as DashboardAlertNotificationRowComponent } from "@containers/Dashboard/components/DashboardHospitalContainer/AlertNotificationsCard/AlertNotificationRowComponent";
import { AlertNotificationRowComponent as AlertAlertNotificationRowComponent } from "@containers/Alert/components/AlertNotificationsListContainer/AlertNotificationsList/AlertNotificationRowComponent";

export const getAlertNotificationsListTableProperties = (
  onClickMarkAsRead?: (alertNotification: AlertNotification) => void,
  patientSettings?: PatientSettings,
): TableProperty<AlertNotification>[] => {
  return [
    {
      key: "id",
      title: "",
      get: (item) => {
        return patientSettings ? (
          <AlertAlertNotificationRowComponent
            item={item}
            patientSettings={patientSettings}
            onClickMarkAsRead={onClickMarkAsRead}
          />
        ) : (
          <DashboardAlertNotificationRowComponent item={item} />
        );
      },
    },
  ];
};
